<template>
  <div id="mall">
    <div>
      <div class="d-flex pt-2 pl-2">
        <router-link to='/mall' style="width: 100%">
        <span class="icon-cube" style="color:#5cd9e8;font-size: 0.3rem;width: 100%">
           <span class="fs-xl text mx-2" style="font-size: 0.25rem;color: #ffffff">易智商城</span>

        </span>
        </router-link>
<!--        <el-button icon="el-icon-video-camera" size="medium" @click="dialogVisible=true" class="float-r">视频</el-button>-->

<!--        <el-dialog :visible.sync="dialogVisible" :modal-append-to-body="false" title="视频" >-->
<!--          <video  controls src="@/assets/video/mv.mp4"-->
<!--                  width="100%" height="500px">-->
<!--          </video>-->
<!--        </el-dialog>-->
      </div>
      <div class="d-flex jc-center body-box" style=" margin-top: 0;">
        <Echart id="mallChart"
                :options="option"
                height="3.2rem"
                width="100%"></Echart>

      </div>
    </div>
  </div>
</template>

<script>
// import centerRight2Chart1 from "@/components/echart/centerRight/centerRightChart";
import Echart from "@/common/echart/index";
import sciApi from '@/api/index.js'
let Chart
export default {
  data() {
    return {
      tag:'',
      option:{},
      dialogVisible: false,
      videoUrl:'',
      property:[],
      Num:{
        '知识产权':0,
        '法律服务':0,
        '政策申报':0,
        '工商财税':0,
        '检验检测':0,
        '科技咨询':0,
        '服务机构':0,
        '评估评价':0,
      }
    };
  },
  components: {
    Echart
  },
  watch:{
    setregion:{
      immediate: true,
      deep: true,
      handler(val) {
        this.tag = val
      }
    },
    tag:{
      immediate: false,
      deep: true,
      handler(val) {
        console.log(val,'val')
        this.init().then(()=>{
          let num=[]
          for (let key in this.Num){
            num.push({ name:key,
              value:this.Num[key]})
          }
          this.option.series[0].data=num
          Chart.setOption(JSON.parse(JSON.stringify(this.option)),true);
        })
      }

    }
  },
  created() {

  },
  computed:{
    setregion() {
      // console.log(this.$store.state.region)
      return this.$store.state.region
    }
  },
  // components: { centerRight2Chart1 },
  mounted() {
    this.tag=''
    this.init().then(()=>{
      let num=[]
      for (let key in this.Num){
        num.push({ name:key,
          value:this.Num[key]})
      }
      this.option.series[0].data=num
      Chart.setOption(JSON.parse(JSON.stringify(this.option)),true);
    })
    this.option = {
      color: [
        "#37a2da",
        "#32c5e9",
        "#9fe6b8",
        "#ffdb5c",
        "#ff9f7f",
        "#fb7293",
        "#e7bcf3",
        "#8378ea"
      ],
      tooltip: {
        trigger: "item",
        formatter: "{b}<br/>{c}个"
      },
      toolbox: {
        show:false,
        top:20,
      },
      legend: {
        selectedMode:false,
        orient: 'vertical',
        right: 20,
        top:20,
       itemWidth:15,
        textStyle:{
          lineHeight:12,
          padding:3,
        }
      },
      calculable: true,
      series: [
        {
          label: {
            formatter: "{number|{c}}个\n{b}",
            rich: {
              number: {
                fontSize: 16,
                color: '#fff',
              }
            }
          },
          name: "数据统计",
          type: "pie",
          radius: [0, 100],
          roseType: "area",
          center: ["40%", "50%"],
          data: []
        }]
    };
    this.drawLine();

  },
  methods: {
      async init(){
        const that = this;
        // await sciApi.selectMall({})
        await sciApi.selectMall({pageSize: 1000,pageNum: 1}).then((data)=>{
          // data 就是接口返回值
          this.property = data.list || []
          if(this.tag!==''){
            this.property.forEach((item) => {
              if(item.mapAreaDisplay == that.tag)
              {
                that.Num[item.level1Display] += parseInt(item.mapNum);
              }else {
                that.Num[item.level1Display] = 0;
              }
            })
          }else {
            this.property.forEach((item) => {
                that.Num[item.level1Display] += parseInt(item.mapNum);
            })
            console.log(Object.keys(this.Num))
          }
        })
      },
    drawLine:function (){
      //基于准备好的dom，初始化echarts实例
      Chart = this.$echarts.init(document.getElementById('mallChart'))
      Chart.setOption(this.option);
      // option && myChart.setOption(option);
    },
    setOption(){
      // if(!Chart.clear) return
      // Chart.clear()
      // for(let key in setdata){
      //   if(this.tag == key){
      //     this.option.series[0].data = setdata[key];
      //     console.log(this.option.series)
      //     Chart.setOption(JSON.parse(JSON.stringify(this.option)),true);
      //   }
      // }
      // option && myChart.setOption(option);
    }
  }
};
</script>

<style lang="scss">
#mall{
  padding: 0.2rem;
  height: 100%;
 width: 100%;
  border-radius: 0.0625rem;
  .bg-color-black {
    padding: 0.0625rem;
    height: 4.5rem;
    border-radius: 0.125rem;
  }
  .text {
    color: #c3cbde;
  }
  .body-box {
    border-radius: 0.125rem;
    overflow: hidden;
  }
}
</style>